import { useEffect } from 'react';
import { useSupportStore, type KnownIssue } from '../stores/supportStore';
import { theme } from '../theme';

const styles = {
  container: { maxWidth: '760px', margin: '0 auto', padding: '32px 24px' },
  title: { fontSize: '24px', fontWeight: 700, color: theme.textPrimary, marginBottom: '8px' },
  intro: { color: theme.textSecondary, fontSize: '14px', marginBottom: '24px' },
  heading: { fontSize: '16px', fontWeight: 600, color: theme.textPrimary, margin: '24px 0 12px' },
  issue: {
    background: theme.bgPanel,
    border: `1px solid ${theme.border}`,
    borderRadius: theme.radiusLg,
    padding: '16px 20px',
    marginBottom: '12px',
  },
  issueTitle: { fontSize: '15px', fontWeight: 600, color: theme.textPrimary },
  body: {
    color: theme.textSecondary,
    fontSize: '14px',
    marginTop: '6px',
    whiteSpace: 'pre-wrap' as const,
  },
  meta: { color: theme.textMuted, fontSize: '12px', marginTop: '8px' },
  empty: { color: theme.textMuted, fontSize: '14px' },
};

function day(ms: number): string {
  return new Date(ms).toLocaleDateString();
}

function Issue({ issue }: { issue: KnownIssue }) {
  return (
    <div style={styles.issue}>
      <div style={styles.issueTitle}>{issue.title}</div>
      {issue.body && <div style={styles.body}>{issue.body}</div>}
      <div style={styles.meta}>
        {issue.status === 'fixed' && issue.fixedAt
          ? `Fixed ${day(issue.fixedAt)}`
          : `Posted ${day(issue.createdAt)}`}
      </div>
    </div>
  );
}

export function KnownIssues() {
  const { knownIssues, loadKnownIssues } = useSupportStore();

  useEffect(() => {
    loadKnownIssues();
  }, [loadKnownIssues]);

  const open = knownIssues.filter((i) => i.status === 'open');
  const fixed = knownIssues.filter((i) => i.status === 'fixed');

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Known issues</h1>
      <div style={styles.intro}>
        Problems we already know about in the Lune beta. If yours isn&apos;t here, use Report a
        problem.
      </div>
      {open.length === 0 && fixed.length === 0 && (
        <div style={styles.empty}>No known issues right now.</div>
      )}
      {open.map((issue) => (
        <Issue key={issue.id} issue={issue} />
      ))}
      {fixed.length > 0 && (
        <>
          <div style={styles.heading}>Recently fixed</div>
          {fixed.map((issue) => (
            <Issue key={issue.id} issue={issue} />
          ))}
        </>
      )}
    </div>
  );
}
